import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { AppStateService } from '../services/app-state.service';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard implements CanActivate {

  accessToken: string;

  constructor(private appState: AppStateService) {
    // this.appState.getAccessToken.pipe(take(1)).subscribe(accessToken => this.accessToken = accessToken);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    // console.log(route.paramMap.get('t'));
    return true;

    // if (this.accessToken) {
    //   return true;
    // } else {
    //   return;
    // }
  }
}
